import tempIcon from "@/img/temp-icon.svg";
import feelLikeIcon from "@/img/feels-like-icon.svg";
import windIcon from "@/img/wind-direction-map-icon.svg";
import windSpeedIcon from "@/img/wind-speed-icon.svg";
import humidityIcon from "@/img/humidity-icon.svg";
import precipitationIcon from "@/img/precipitation-icon.svg";
import visibilityIcon from "@/img/visibility-icon.svg";

import { IControl } from "@/components/map-container/types/map-type";

export const STATION_BUTTONS: IControl[] = [
	{
		text: "airTemperature",
		img: tempIcon,
		isActive: true,
		value: "temperature",
	},
	{
		text: "feelLikeWithUnits",
		img: feelLikeIcon,
		isActive: false,
		value: "feel_like",
	},
	{
		text: "windDirection",
		img: windIcon,
		isActive: false,
		value: "wind_direction",
	},
	{
		text: "windSpeedKmh",
		img: windSpeedIcon,
		isActive: false,
		value: "wind_speed",
	},
	{
		text: "relativeHumidity",
		img: humidityIcon,
		isActive: false,
		value: "relative_humidity",
	},
	{
		text: "precipitation",
		img: precipitationIcon,
		isActive: false,
		value: "precipitation_3h",
	},
	{
		text: "visibilityWithUnits",
		img: visibilityIcon,
		isActive: false,
		value: "visibility",
	},
];
